// Mind2Magic CRM — Centralized Mutable State
// All shared state lives here. Modules import { store } and read/write store.xxx.
// Usage: import { store } from './store.js'; store.leads = [...];

import { defaultSettings } from './constants.js'

export const store = {
    // Auth
    currentUser: null,

    // Core data
    clients: {},
    leads: [],
    historico: [],
    showHistorico: false,
    modoCompleto: false,
    ocultarValores: false,
    team: [
        { id: 't1', nombre: 'Sara', rol: 'Directora', email: 'sara.mind2magic@gmail.com' },
        { id: 't2', nombre: 'Matías', rol: 'Operaciones/Financiero', email: 'contact.mind2magic@gmail.com' },
    ],
    tareas: [],

    // Settings
    settings: { ...defaultSettings },
    plantillasTemp: null,

    // Empresas (B2B)
    crmMode: 'turismo',
    companies: [],
    companyBookings: [],
    empSelectionMode: false,
    empSelectedBookings: new Set(),

    // Import temps
    importData: null,
    foundDup: null,
    currentLeadId: null,
    currentPeriod: 'todo',
    currentFileName: '',
    tfImportData: null,
    pdfExtractedData: null,
    pendingExcelRow: null,

    // Theme — initialized with time-based logic
    currentTheme: (() => {
        const saved = sessionStorage.getItem('m2m_crm_theme');
        if (saved) return saved;
        const hour = new Date().getHours();
        return (hour >= 19 || hour < 7) ? 'dark' : 'light';
    })(),

    // Undo/redo
    undoStack: [],
    redoStack: [],

    // Selection (turismo)
    selectionMode: false,
    selectedLeads: new Set(),
    isDragging: false,
    dragStartX: 0,
    dragStartY: 0,
    selectionBox: null,

    // Form submissions
    pendingFormSubmissions: [],
    allFormSubmissions: [],
    formSubsLoaded: false,
    allGuideSessions: [],
    formPeriod: 'todo',
    formStatusFilter: 'todos',
    formSortField: 'created_at',
    formSortDir: 'desc',
    formSelectedIds: new Set(),
    allFormSessions: [],
    formSessionsLoaded: false,

    // Internal tracking sets
    _processedSubmissionIds: new Set(),
    _recentSyncs: new Set(),

    // KPIs
    _kpiFormsLoaded: false,
    kpiPeriod: 'mes',
    kpiCustomStart: null,
    kpiCustomEnd: null,
    kpiShowCompare: true,

    // Dashboard
    currentDashScope: 'turismo',
    _hitosFilterTipo: 'todos',
    _hitosFilterPeriodo: '14',

    // Calendar
    calCurrentDate: new Date(),
    calendarSearchQuery: '',
    calPickerSelectedYear: new Date().getFullYear(),
    calDayEventsCache: [],

    // Viajeros
    currentViajeroLeadId: null,

    // Form popovers
    _activePopoverBtn: null,

    // Number format: 'en-US' (US: $2,471.01) or 'es-CO' (LATAM: $2.471,01)
    numberFormat: 'en-US',

    // Zoom
    currentNavZoom: 1,
    currentTopZoom: 1,
    currentLeadsZoom: 1,
    currentZoomScale: 1,
    _activeZoomEdit: null,
    _lastLeadsScale: 1,

    // Client Dashboards
    _dashboardCache: {},  // leadId → dashboard row

    // WhatsApp Messages
    whatsappMessages: {},  // leadSupabaseId → messages[]
    unmatchedWaMessages: [],
    waLeadSummaries: {},

    // Empresas drag
    empIsDragging: false,
    empDragStartX: 0,
    empDragStartY: 0,
    empSelectionBox: null,
}
